import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AppValidators} from "../../../util/app-validators";
import {GeneralEmail, GeneralEmailService} from "../../../lib/email-template/general-email.service";
import {Services} from "../../../lib/util/services";
import {StringKey} from "../../../app.string-keys";
import {ToasterService} from "../../../fork/angular2-toaster/src/toaster.service";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {UiConstants} from "../../../util/core-utils";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-colonnade-insurance-email-send-dialog',
  templateUrl: './colonnade-insurance-email-send-dialog.component.html',
  styleUrls: ['./colonnade-insurance-email-send-dialog.component.scss']
})
export class ColonnadeInsuranceEmailSendDialogComponent implements OnInit {
  static readonly manualEmailTemplate = 'colonnade_mail_template_manual';
  UiConstants = UiConstants;
  emailSendForm: FormGroup;
  emailSendModel: EmailSendModel;

  constructor(
    public dialogRef: MatDialogRef<ColonnadeInsuranceEmailSendDialogComponent, ColonnadeEmailSendDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ColonnadeEmailSendDialogData,
    private emailService: GeneralEmailService,
    private fb: FormBuilder,
    private translateService: TranslateService,
    private toasterService: ToasterService) {
    this.emailSendForm = fb.group({
      recipientName: ['', Validators.required],
      recipientEmailAddress: ['', [Validators.required, AppValidators.validateOptionalEmail]]
    });
    this.emailSendModel = new EmailSendModel(data.generalPdfIds);
  }

  public static openDialog(
    dialog: MatDialog,
    data: ColonnadeEmailSendDialogData,
    resultCallback?: (result?: ColonnadeEmailSendDialogResult) => void): MatDialogRef<ColonnadeInsuranceEmailSendDialogComponent, ColonnadeEmailSendDialogResult> {
    const dialogRef = dialog.open(ColonnadeInsuranceEmailSendDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '320px',
      height: 'auto',
      panelClass: 'custom-dialog-container',
      backdropClass: 'transparent-backdrop',
    });
    dialogRef.afterClosed().subscribe((result?: ColonnadeEmailSendDialogResult) => {
      if (resultCallback) {
        resultCallback(result);
      }
    });
    return dialogRef;
  }


  ngOnInit(): void {
  }

  sendEmail() {
    if (!this.emailSendForm.valid) {
      this.emailSendForm.get('recipientName')!.markAsTouched();
      this.emailSendForm.get('recipientEmailAddress')!.markAsTouched();
      return;
    }
    const request = this.emailSendModel.toRequest();
    this.emailService.sendEmail(request).subscribe((result: GeneralEmail.Result) => {
      this.dialogRef.close();
      switch (result.emailResult.status) {
        case 'SUCCEED':
          this.toasterService.pop({
            timeout: UiConstants.ToastTimeoutLong,
            type: UiConstants.toastTypeSuccess,
            title: this.translateService.instant(StringKey.COMMON_SUCCESS),
            body: this.translateService.instant(StringKey.GENERAL_EMAIL_SEND_SUCCESS)
          });
          break;
        case 'FAILED':
        case 'INVALID_REQUEST':
          this.toasterService.pop({
            timeout: UiConstants.ToastTimeoutLong,
            type: UiConstants.toastTypeError,
            title: this.translateService.instant(StringKey.COMMON_ERROR_DIALOG_TITLE),
            body: this.translateService.instant(StringKey.GENERAL_EMAIL_SEND_RESULT_FAILED, {message: result.emailResult.message})
          });
          break;
        case 'INVALID_RECIPIENT':
          this.toasterService.pop({
            timeout: UiConstants.ToastTimeoutLong,
            type: UiConstants.toastTypeError,
            title: this.translateService.instant(StringKey.COMMON_ERROR_DIALOG_TITLE),
            body: this.translateService.instant(StringKey.GENERAL_EMAIL_SEND_RESULT_INVALID_RECIPIENT, {message: result.emailResult.message})
          });
          break;

      }
    }, error => {
      this.dialogRef.close();
      this.toasterService.pop({
        timeout: UiConstants.ToastTimeoutLong,
        type: UiConstants.toastTypeError,
        title: this.translateService.instant(StringKey.COMMON_ERROR_DIALOG_TITLE),
        body: this.translateService.instant(StringKey.COMMON_ERROR_DIALOG_MESSAGE)
      });
    });
  }

}

class EmailSendModel {
  readonly templateExternalId: string = ColonnadeInsuranceEmailSendDialogComponent.manualEmailTemplate;
  readonly fields: Map<string, string> = new Map();
  recipientName: string = '';
  recipientEmailAddress: string = '';

  constructor(public generalPdfIds: number[]) {
  }

  toRequest(): GeneralEmail.EmailSendRequest {
    return {
      templateExternalId: this.templateExternalId,
      fields: this.fields,
      recipients: [{name: this.recipientName, emailAddress: Services.toEmailAddress(this.recipientEmailAddress)}],
      generalPdfIds: this.generalPdfIds
    };
  }

  isDangerous(): boolean {
    return this.generalPdfIds.length === 0 || this.generalPdfIds.length > 10;
  }
}

export interface ColonnadeEmailSendDialogData {
  generalPdfIds: number[];
}

export interface ColonnadeEmailSendDialogResult {

}
